module.exports = __webpack_public_path__ + "img/c02_unitscout_Normal_ua.f0bfe353.webp";